var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 1.2C15.4 2.6 16.6 3.6 18.1 3.9V6.1C17 6.1 15.9 5.7 14.8 5.2V10.6C14.8 13 12.9 15 10.4 15C7.9 15 6 13 6 10.6C6 8.2 7.9 6.2 10.4 6.2C10.7 6.2 11 6.2 11.3 6.3V8.9C11 8.8 10.7 8.7 10.4 8.7C9.4 8.7 8.6 9.6 8.6 10.6C8.6 11.6 9.4 12.5 10.4 12.5C11.4 12.5 12.2 11.6 12.2 10.6V1.2H14.8Z",
    fill: "#FFFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.e0f4947726d32504b1b70c603747d42f.svg";
export { ForwardRef as ReactComponent };